import PassengerGroupPassenger from "./PassengerGroupPassenger";

export class PassengerGroup {
    id: number;
    organizationId: string;
    name: string;
    description: string
    passengerGroupPassengers: PassengerGroupPassenger[];

    public static fromApi(apiPassengerGroup: any) {
      const passengerGroup = new PassengerGroup();
      passengerGroup.id = apiPassengerGroup.id;
      passengerGroup.organizationId = apiPassengerGroup.organizationId;
      passengerGroup.name = apiPassengerGroup.name;
      passengerGroup.description = apiPassengerGroup.description;
      if (apiPassengerGroup.passengerGroupPassengers && apiPassengerGroup.passengerGroupPassengers.length > 0) {
          passengerGroup.passengerGroupPassengers = apiPassengerGroup.passengerGroupPassengers
          .map(p => new PassengerGroupPassenger(p));
      } else {
        passengerGroup.passengerGroupPassengers = [];
      }

      return passengerGroup;
    }
}
